export default {
  LANDING_URL: 'https://www.vestbee.com',
  STATIC_URL: '/static/',
}
